import { axiosInstance } from '../../utils'
import type { AppTableField, AppTableRecord, Chat, SpaceNode } from './types'

export * from './types'

const baseURL = '/api/notify'

export function listChat(): Promise<Chat[]> {
  return axiosInstance.get('/messages/chats', {
    baseURL,
  })
}

export function listBitableField(app_token: string, table_id: string, params?: {
  view_id: string
}): Promise<AppTableField[]> {
  return axiosInstance.get(`/bitable/v1/apps/${app_token}/tables/${table_id}/fields`, {
    baseURL,
    params,
  })
}

export function retrieveBitableRecord(app_token: string, table_id: string, record_id: string): Promise<AppTableRecord> {
  return axiosInstance.get(`/bitable/v1/apps/${app_token}/tables/${table_id}/records/${record_id}`, {
    baseURL,
  })
}

export function retrieveWiKiSpaceNode(token: string): Promise<{ node: SpaceNode }> {
  return axiosInstance.get('/wiki/v2/spaces/get_node', {
    baseURL,
    params: {
      token,
    },
  })
}
